import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { focusRing } from "../foundations/focus";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tabsAnatomy.keys);

const steps = definePartsStyle({
  tablist: {
    display: "block",
    borderBottom: "none",
  },
  tab: {
    w: "100%",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    gap: "clamp(16px, 2vw, 28px)",
    px: 0,
    py: "clamp(20px, 2.4vw, 30px)",
    textAlign: "left",
    borderBottom: "1px solid",
    borderColor: "line.hairline",
    _first: {
      borderTop: "1px solid",
      borderColor: "line.hairline",
    },
    _focusVisible: focusRing,
  },
  tabpanel: {
    p: 0,
  },
});

export const Tabs = defineMultiStyleConfig({
  variants: { steps },
});
